import Rails from "@rails/ujs"
import { Collapse } from "bootstrap"
import "controllers"
import 'daterangepicker/daterangepicker.css'

Rails.start()
